export type Address = {
  streetNumber: string;
  streetName: string;
  city: string;
  province?: string | null;
  postalCode: string;
  country: string;
};

export type AddressInput = {
  address: Address;
};

export interface ICoordinates {
  latitude: number;
  longitude: number;
}

export enum LocationModalState {
  SHOW = "SHOW",
  DEACTIVATE = "DEACTIVATE",
  MINIMIZE = "MINIMIZE",
}
